import { render, staticRenderFns } from "./v12.vue?vue&type=template&id=5d9e854e&scoped=true&"
import script from "./v12.vue?vue&type=script&lang=js&"
export * from "./v12.vue?vue&type=script&lang=js&"
import style0 from "./v12.vue?vue&type=style&index=0&id=5d9e854e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e854e",
  null
  
)

export default component.exports